import { Fetch } from '../shared/general';

//#region ======== ACTIONS ========
const actions = {
    //======== CLAIM MANAGEMENT ======
    department_department_create      : "department_department_create",
    department_list_get          : "department_list_get",
    department_id_get            : "department_id_get",
    department_department_update      : "department_department_update",
};
//#endregion


//#region ========== API FUNCTIONS ===========
export function department_department_create(data){
    return Fetch({ action: actions.department_department_create, data: data });
}

export function department_list_get(data){ 
    return Fetch({ action: actions.department_list_get, data: data });
}

export function department_id_get(data){
    return Fetch({ action: actions.department_id_get, data: data });
}

export function department_department_update(data){
    return Fetch({ action: actions.department_department_update, data: data });
}

// export function branch_branch_remove(data){
//     return Fetch({ action: actions.branch_branch_remove, data: data });
// }